import { setIdReduxAction } from '../../../../redux/actions/set-id'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_PATH from '../../constants/path'

function setSuggestedWorkoutAction (instance) {
  return setIdReduxAction({
    type: instance
      ? WORKOUTS_ACTION.UPDATE_SUGGESTED
      : WORKOUTS_ACTION.RESET_SUGGESTED,
    payload: {
      path: WORKOUTS_PATH.SUGGESTED,
      instance
    }
  })
}

export default setSuggestedWorkoutAction
